// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3KCZ3","productName":"Table_productName__3L4sx"};